import { render, staticRenderFns } from "./SellerDataComponent.vue?vue&type=template&id=210d2377&"
import script from "./SellerDataComponent.vue?vue&type=script&lang=js&"
export * from "./SellerDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports